import { GetFinalPdfData } from 'pages/package-page/package-page.props';
import axiosInstance from '../shared/api/axios-instance';

export async function getListProducts(body = {}) {
  const response = await axiosInstance({
    method: 'POST',
    url: 'CrmCheckout/ListProducts',
    data: body
  });

  const { data } = response.data;

  return data;
}

export async function getCompanyPackage(data = {}) {
  const axiosConfig = {
    method: 'POST',
    url: 'CrmCheckout/GetCompanyPackage',
    data
  };
  return axiosInstance(axiosConfig);
}

export async function getAvailablePackages(data = {}) {
  const response = await axiosInstance({
    method: 'POST',
    url: 'CrmCheckout/GetAvailablePackages',
    data
  });

  const { items } = response.data.data;

  // console.log(items);
  return response;
}

export async function updateCheckoutData(data = {}) {
  return axiosInstance({
    method: 'POST',
    url: 'CrmCheckout/UpdateCheckoutData',
    data
  });
}

export async function getPricelistFilesList(data = {}) {
  return axiosInstance({
    method: 'POST',
    url: 'CrmCheckout/GetPreislisteFilesList',
    data
  });
}

export async function assignProducts(data = {}) {
  return axiosInstance({
    method: 'POST',
    url: 'CrmCheckout/AssignProducts',
    data
  });
}

export async function getContractPDFPreview(data = {}) {
  return axiosInstance({
    method: 'POST',
    url: 'CrmCheckout/GetContractPDFPreview',
    responseType: 'blob',
    data
  });
}

export async function getContractZip(data = {}) {
  return axiosInstance({
    method: 'POST',
    url: 'CrmCheckout/GetContractZip',
    responseType: 'blob',
    data
  });
}

export async function GetFinalZip(data: GetFinalPdfData) {
  return axiosInstance({
    method: 'POST',
    url: 'CrmCheckout/GetFinalZip',
    responseType: 'blob',
    data
  });
}

export async function getAccountData(id: string) {
  const response = await axiosInstance({
    method: 'POST',
    url: 'CrmCheckout/GetAccountData',
    data: {
      id
    }
  });

  const { data } = response.data;

  return data;
}
